import { useSelector } from 'react-redux'

import { selectFilterOptions } from 'redux/selectors/FilterOptions'

/**
 * Hook for all filter options
 * per attribute option
 */
export const useFilterOptions = () => {
  return useSelector(selectFilterOptions)
}
